export default function getAggregateEvents(invokeFunction) {
  return (id, options) => {
    // support for previous signature
    if (typeof options === 'number') {
      options = { after: options };
    }

    return invokeFunction('event', { id, options });
  };
}
